module.exports = __webpack_public_path__ + "static/house-4-d4681b3dbc787bf3e13c71ca48a0a324.png";